import { IProductListPatchModelItem } from '@epicuro-next/data/lists';
import { List, Media } from '@epicuro-next/models/engagement';
import { createAction, props } from '@ngrx/store';
import { Product } from 'graphql-api/gql-api-interfaces';

export const listClosed = createAction(
  '[ProductList] Close list',
  props<{ id: string }>(),
);

export const setOpenedList = createAction(
  '[ProductList] Set Opened List',
  props<{ id: string }>(),
);

export const setOpenedListSuccess = createAction(
  '[ProductList] Set Opened List success',
  props<{ list: List }>(),
);
export const setOpenedListError = createAction(
  '[ProductList] Set Opened List error',
);

export const loadOpenedListProducts = createAction(
  '[ProductList] Load products in opened List',
  props<{ samePage: boolean }>(),
);

export const loadOpenedListProductsSuccess = createAction(
  '[ProductList] Load products in opened List Success',
  props<{
    products: Product[];
    samePage?: boolean;
    total?: number;
    addToTop?: boolean;
  }>(),
);

export const loadOpenedListProductsError = createAction(
  '[ProductList] Load Opened List products error',
);

export const deleteProductFromOpenedList = createAction(
  '[ProductList] Delete product from opened list',
  props<{ product: Product }>(),
);
export const deleteProductFromOpenedListSuccess = createAction(
  '[ProductList] Delete product from opened list success',
  props<{ products: IProductListPatchModelItem[] }>(),
);

export const addProductToOpenedListSuccess = createAction(
  '[ProductList] Add products to opened list success',
  props<{ products: IProductListPatchModelItem[] }>(),
);

export const resetOpenedListProducts = createAction(
  '[ProductList] Reset products from opened list',
);

export const reorderProductInOpenedList = createAction(
  '[ProductList] Reorder product in list',
  props<{ brandId: string; productId: string; order: number }>(),
);

export const reorderProductInOpenedListSuccess = createAction(
  '[ProductList] Reorder product in list success',
  props<{ listId: string; productId: string; order: number }>(),
);

export const clearOpenedList = createAction('[ProductList] Clear opened list');

export const updateOpenedListProductsWithDiscounts = createAction(
  '[ProductList] Update opened list products with discounts',
  props<{ products: Product[] }>(),
);

export const setOpenedListMedia = createAction(
  '[ProductList] Set list media',
  props<{ media: Media }>(),
);

export const shopTheList = createAction(
  '[ProductList] Shop the current list of products',
);

export const shopTheListError = createAction(
  '[ProductList] Shop the current list of products error',
);

export const setFullList = createAction(
  '[ProductList] Set full product list',
  props<{ list: Product[] }>(),
);

export const deleteProductsFromOpenedList = createAction(
  '[ProductList] Delete products from opened list',
  props<{ products: Product[] }>(),
);
